import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  PodSticker,
  PodSection,
  PodFooter,
  PodSpacer,
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductSponsored,
  ProductRating,
  ProductIdentifier,
  ProductATC
} from '@thd-olt-component-react/product-pod';
import {
  bool as boolType,
  string as stringType,
  number as numType
} from 'prop-types';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';

export const RecsProductPod = (props) => {
  const {
    // eslint-disable-next-line react/prop-types
    itemId,
    storeId,
    position,
    parent,
    hideSwatches,
    hideFavorites,
    hideBadge,
    hideATC,
    hideRating,
    scheme,
    anchorProduct,
    preferredPriceFlag,
    brandTitleMaxLine,
    strategy,
    zoneName,
    zonePosition,
    podResults
  } = props;

  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{
        parent, position, scheme, anchorProduct, strategy, zoneName, zonePosition, podResults
      }}
      render={(pod) => (
        <>
          <PodSticker noPadding position="top-left">
            {!hideBadge && <ProductBadge itemId={pod.itemId} storeId={storeId} />}
          </PodSticker>
          {!hideFavorites
            && (
              <PodSticker position="top-right">
                <PodSpacer padding={['RIGHT']}>
                  <Favorite
                    itemId={pod.itemId}
                    storeId={storeId}
                    showCircle
                    showCount={false}
                    showHoverInfo
                  />
                </PodSpacer>
              </PodSticker>
            )}
          <ProductImage
            itemId={pod.itemId}
            showSecondaryImage={pod.showSecondaryImage}
            onClick={() => { }}
          />
          {!hideSwatches
            && (
              <SuperSkuMiniSwatches
                itemId={pod.itemId}
                storeId={storeId}
                onChange={pod.onChange}
                onHover={pod.onSSKUHover}
              />
            )}
          <PodSection columnAlign>
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <ProductHeader
                brand="above"
                itemId={pod.itemId}
                brandTitleMaxLine={brandTitleMaxLine}
                disableShopThisCollection
              />
            </PodSpacer>
            {!hideRating && (
              <ProductRating itemId={pod.itemId} hideRating={hideRating} />
            )}
            <Price
              itemId={pod.itemId}
              large={false}
              storeId={storeId}
              displayEachUom={false}
              hideSavingsText={!preferredPriceFlag}
              showPreferredPricingBadge
            />
          </PodSection>
          {!hideATC
            && (
              <PodFooter>
                <PodSpacer minHeight="40px">
                  <ProductATC
                    itemId={pod.itemId}
                    checkGeneric
                    outline
                  />
                </PodSpacer>
              </PodFooter>
            )}
        </>
      )}
    />
  );
};

RecsProductPod.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductSponsored,
  ProductRating,
  ProductIdentifier,
  ProductATC,
  Price,
  ProductHeader,
  SuperSkuMiniSwatches,
  Favorite,
);

RecsProductPod.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  storeId: stringType,
  position: numType,
  parent: stringType,
  hideSwatches: boolType,
  hideFavorites: boolType,
  hideBadge: boolType,
  hideATC: boolType,
  hideRating: boolType,
  scheme: stringType,
  anchorProduct: stringType,
  preferredPriceFlag: boolType,
  brandTitleMaxLine: numType,
  strategy: stringType,
  zoneName: stringType,
  zonePosition: stringType,
  podResults: numType,
};

RecsProductPod.defaultProps = {
  storeId: '',
  position: '',
  parent: '',
  hideSwatches: true,
  hideFavorites: true,
  hideBadge: false,
  hideATC: false,
  hideRating: false,
  scheme: 'drecs',
  anchorProduct: '',
  preferredPriceFlag: false,
  brandTitleMaxLine: 4,
  strategy: 'project-based',
  zoneName: '',
  zonePosition: '',
  podResults: 0,
};
RecsProductPod.displayName = 'RecsProductPod';
